import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { desc } from "../../../lib/chartDescription";
import { useRedditPropertyData } from "../../../lib/hooks";
import {
  listing_options,
  post_catergory_options,
  reddit_table_options,
  time_filter_options,
} from "../../../lib/twitterAPI";
import getMonthName, { roundNumber } from "../../../lib/util";
import styles from "./../../../styles/charts/chartStyle.module.css";
import BarChart from "../protoCharts/BarChart";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "../twitter/TwitterWordCloud";
import {
  propertyNameOptionSet1RedditProperty,
  propertyNameOptionSet2RedditProperty,
} from "./RedditProperty";

interface TwitterPropertyProps {
  type?: "ByMonth" | "ByYear";
}
export default function RedditPropertyBar(props: TwitterPropertyProps) {
  const { type = "ByYear" } = props;
  const [chartData, setChartData] = useState<{
    data: any[];
    labels: any[];
  } | null>(null);

  // const [showAll, setShowAll] = useState(false);

  const [distribution, setDistribution] = useState<string | undefined>(
    undefined
  );
  const [activeYear, setActiveYear] = useState<string | undefined>(undefined);

  const [postCategory, setpostCategory] = useState(post_catergory_options[0]);

  const [timeFilter, settimeFilter] = useState(time_filter_options[0]);

  const [listing, setListing] = useState(listing_options[0]);

  const [redditTable, setRedditTable] = useState(reddit_table_options[0]);

  // THis propertName will depend upon the value of reddit table selection
  // "property_name" (Required)
  // Options value according to reddit_table parameter
  // 	<|
  // 		RedditPosts->
  // 			{Number of Posts,Mean Score,Mean Ups,Mean Downs,Mean Comments}
  // 		RedditComments->
  // 			{Number of Comments,Mean Score,Mean Ups,Mean Downs}
  // 	|>
  const [propertyName, setpropertyName] = useState(
    redditTable === reddit_table_options[0]
      ? propertyNameOptionSet1RedditProperty[0]
      : propertyNameOptionSet2RedditProperty[0]
  );

  //this is required in case of type === "byyear"
  const [showAll, setShowAll] = useState(false);

  const { redditPropertyData, loading, error } = useRedditPropertyData(
    type === "ByYear"
      ? {
          reddit_table: redditTable,
          property_name: propertyName,
          group_by_year: false,
          create_keyword_items: false,
          group_by_month: false,
          create_year_items: false,
          time_filter: timeFilter,
          listing,
          post_category: postCategory,
        }
      : {
          reddit_table: redditTable,
          property_name: propertyName,
          group_by_year: true,
          create_keyword_items: true,
          group_by_month: true,
          create_year_items: true,
          time_filter: timeFilter,
          listing,
          post_category: postCategory,
        }
  );

  // !loading &&
  //   error === null &&

  // console.log(distributionData);

  let yearOption = redditPropertyData
    ?.filter((item) => item.keyword === distribution)[0]
    ?.items.map((subItem: any) => `${subItem.year.toString()}`);

  useEffect(() => {
    let dataForChart: any[] = [];
    let labels: any[] = [];

    if (loading) {
      setChartData({ data: [], labels: [] });
      setDistribution(undefined);
      setActiveYear(undefined);
      return;
    }

    if (!loading && error === null) {
      if (type === "ByYear") {
        let count = 0;
        redditPropertyData.forEach((item) => {
          if (count < 10 || showAll) {
            dataForChart.push(roundNumber(item.value));
            labels.push(item.keyword);
          }
          count = count + 1;
          // console.log(item);
        });
        setChartData({ data: dataForChart, labels });
      } else {
        setDistribution(redditPropertyData[0].keyword);
        setActiveYear(redditPropertyData[0].items[0].year);
        redditPropertyData[0].items[0].items.forEach((item: any) => {
          dataForChart.push(roundNumber(item.value));
          labels.push(getMonthName(item.tweet_mont));
          // labels.push(`${item.year}-${subItem.month}-01`);
        });
        console.log(dataForChart);
        setChartData({ data: dataForChart, labels });
      }
    }
    //eslint-disable-next-line
  }, [loading, showAll]);

  useEffect(() => {
    if (distribution !== undefined && activeYear !== undefined) {
      setActiveYear(
        redditPropertyData.filter((item) => item.keyword === distribution)[0]
          .items[0].year
      );
    }
    //eslint-disable-next-line
  }, [distribution]);

  useEffect(() => {
    let data: any[] = [];
    let labels: any[] = [];

    if (distribution !== undefined && activeYear !== undefined) {
      if (type === "ByMonth") {
        console.log(distribution);
        console.log(activeYear);
        redditPropertyData
          .filter((item) => item.keyword === distribution)[0]
          ?.items.filter(
            (subItem: any) => subItem.year === parseInt(activeYear)
          )[0]
          ?.items.forEach((keys: { value: any; month: any }) => {
            data.push(roundNumber(keys.value));
            labels.push(getMonthName(keys.month));
          });
        setChartData({ data: data, labels });
      }
    }
    //eslint-disable-next-line
  }, [distribution, activeYear]);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter" style={{ paddingRight: "20px" }}>
          <Typography
            className={styles.chartHeader}
          >{`${propertyName} of ${postCategory}`}</Typography>
        </div>
        <div className="horizontalCenter">
          <div className={styles.selectOptionRowWordCloud}>
            <Autocomplete
              // autoComplete
              id="combo-box-demo"
              fullWidth
              options={reddit_table_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: string | null) => {
                // setValue(newValue);
                setRedditTable(newValue as string);
                newValue === reddit_table_options[0]
                  ? setpropertyName(propertyNameOptionSet1RedditProperty[0])
                  : setpropertyName(propertyNameOptionSet2RedditProperty[0]);
                // console.log(newValue);
              }}
              disableClearable
              value={redditTable as string}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // can be used to style  input later on
                  // InputProps={{ style: { fontSize: 14 } }}
                  label="Reddit Table"
                />
              )}
            />
            <Autocomplete
              // autoComplete
              id="combo-box-demo"
              fullWidth
              options={post_catergory_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: string | null) => {
                // setValue(newValue);
                setpostCategory(newValue as string);
                // console.log(newValue);
              }}
              disableClearable
              value={postCategory as string}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // can be used to style  input later on
                  // InputProps={{ style: { fontSize: 14 } }}
                  label="Post Category"
                />
              )}
            />
            <Autocomplete
              // autoComplete
              fullWidth
              id="combo-box-demo"
              options={
                redditTable === reddit_table_options[0]
                  ? propertyNameOptionSet1RedditProperty
                  : propertyNameOptionSet2RedditProperty
              }
              // isOptionEqualToValue={(option, value) =>
              //   option.label === value.label
              // }
              // sx={{ width: "40%" }}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: any) => {
                // setValue(newValue);
                setpropertyName(newValue);
                // console.log(newValue);
              }}
              disableClearable
              value={propertyName}
              renderInput={(params) => (
                <TextField {...params} label="Select Property" />
              )}
            />
            {["Controversial Posts", "Top Posts", "Keyword Posts"].includes(
              postCategory
            ) && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={time_filter_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  settimeFilter(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={timeFilter as string}
                renderInput={(params) => (
                  <TextField {...params} label="Time Filter" />
                )}
              />
            )}
            {"Keyword Posts" === postCategory && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={listing_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setListing(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={listing as string}
                renderInput={(params) => (
                  <TextField {...params} label="Listing" />
                )}
              />
            )}
            {type === "ByYear" && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showAll}
                    onChange={() => setShowAll(!showAll)}
                  />
                }
                label={"Show All"}
              />
            )}
            {distribution && (
              <Autocomplete
                // autoComplete
                // multiple={true}
                id="combo-box-demo"
                options={redditPropertyData.map((item) => item.keyword)}
                // isOptionEqualToValue={(option, value) => option.label === value}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setDistribution(newValue as string);
                  console.log(newValue);
                }}
                disableClearable
                value={distribution as string}
                renderInput={(params) => (
                  <TextField {...params} label="Select Keyword" />
                )}
              />
            )}
            {distribution && activeYear && (
              <Autocomplete
                // autoComplete
                // multiple={true}
                id="combo-box-demo"
                options={yearOption || []}
                getOptionLabel={(option) => option.toString()}
                // isOptionEqualToValue={(option, value) => option.label === value}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setActiveYear(newValue as string);
                  console.log(newValue);
                }}
                disableClearable
                value={activeYear as string}
                renderInput={(params) => (
                  <TextField {...params} label="Select Year" />
                )}
              />
            )}
          </div>
        </div>

        <div style={{ width: "100%" }}>
          <>
            {loading && (
              <>
                <BarChart
                  loading={loading}
                  categories={chartData?.labels}
                  chartData={[]}
                  yLabel="Count"
                />
              </>
            )}
            {/* {!loading && error === null && distribution?.length === 0 && (
              <div className="alertContainer">
                <Alert severity="error">Please Select Keyword</Alert>
              </div>
            )} */}
            {chartData && !loading && error === null && (
              <BarChart
                loading={loading}
                categories={chartData.labels}
                chartData={chartData.data}
                yLabel="Count"
              />
            )}
          </>
          {getChartBottomIcons(showMaxButton, setOpen)}
          {type === "ByYear"
            ? getChartInfoIcons(desc["twitter"]["propertyBarYear"])
            : getChartInfoIcons(desc["twitter"]["monthAnalysis"])}
        </div>
      </Paper>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
}
